<template>
  <aside class="menu category-list">
    <ul
      v-if="sortedItems"
      class="menu-list"
    >
      <li
        v-for="item in items"
        :key="item.id"
      >
        <CategoryListItem
          :item="item"
          :is-active="checkActive(item.id)"
          :is-leaf-node="!item.children"
          @link-click="toggleActiveCategory(item.id)"
        />
        <CategoryList
          v-if="item.children"
          :items="item.children"
          :class="{ 'is-hidden': !checkActive(item.id) }"
        />
      </li>
    </ul>
  </aside>
</template>
<script>
import CategoryList from '@/components/organisms/CategoryList'
import CategoryListItem from '@/components/molecules/CategoryListItem'

export default {
  name: 'CategoryList',

  components: {
    CategoryList,
    CategoryListItem,
  },

  props: {
    items: {
      type: Array,
      required: true,
    },
  },

  data() {
    return {
      activeCateIds: [],
    }
  },

  computed: {
    sortedItems() {
      // return this.items.sort((a, b) => a.orderNo - b.orderNo)
      return this.items.sort((a, b) => {
        // aまたはbにorderNoがない場合、その要素を最後にする
        if (a.orderNo == null) return 1 // aにorderNoがなければ、bの後ろに配置
        if (b.orderNo == null) return -1 // bにorderNoがなければ、aの前に配置
        // 両方にorderNoがある場合は数値を比較してソート
        return a.orderNo - b.orderNo
      })
    },
  },

  created() {},

  methods: {
    toggleActiveCategory(id) {
      if (this.activeCateIds.includes(id)) {
        this.activeCateIds = this.activeCateIds.filter((cateId) => cateId !== id)
      } else {
        this.activeCateIds.push(id)
      }
    },

    checkActive(id) {
      return this.activeCateIds.includes(id)
    },
  },
}
</script>
